import React, { Component } from "react";
import { Slider, Row, Col, Tooltip, InputNumber, Divider, Text } from "../../../../GeneralComponents/ui";
import {
  ToolOutlined,
  DeleteOutlined,
  FunctionOutlined
} from "@ant-design/icons";
import i18n from "../../../../../Utils/i18next";
import { TYPE_INPUT, TYPE_SLIDER } from "./WhatIf";
import { decideSeparator } from "../../../../../Utils/NumberLocalization";

export function formatter(value, type) {
  if (type === "percent") {
    return `${value}%`;
  } else {
    return convertNumber(value, type);
  }
}

export function convertNumber(value, dataType) {
  if (dataType === "integer") {
    return Number.parseInt(value);
  } else {
    return Number.parseFloat(value);
  }
}

const numberSeparator = decideSeparator();

class Parameter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentValue: props.parameter.currentValue
        ? props.parameter.currentValue
        : 0,
      marks: {
        0: props.parameter.minValue ? props.parameter.minValue : "0",
        100: props.parameter.maxValue ? props.parameter.maxValue : "100"
      }
    };
  }

  componentDidMount() {
    if (this.props.parameter.dataType === "percent") {
      this.setState({
        marks: {
          0: this.props.parameter.minValue
            ? this.props.parameter.minValue + "%"
            : "0%",
          100: this.props.parameter.maxValue
            ? this.props.parameter.maxValue + "%"
            : "100%"
        }
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.parameter &&
      prevProps.parameter.currentValue !== this.props.parameter.currentValue
    ) {
      this.setState({
        currentValue: this.props.parameter.currentValue
      });
    }
  }


  /** Input parameter changes handle method */
  onChange = (e, minValue, maxValue, dataType) => {
    let value = e.target.value;

    if (value < minValue) {
      value = minValue;
    }

    if (value > maxValue) {
      value = maxValue;
    }

    convertNumber(value, dataType)

    if (!Number.isNaN(value)) {
      if (this.state.currentValue !== value) {
        this.setState({
          ...this.state,
          currentValue: value
        });
      }
    }
  };

  /** Trigger update */
  onTriggerUpdate = (e, minValue, maxValue, dataType) => {
    let value = this.state.currentValue;

    if (value && value !== "") {
      this.props.updateCurrentValue(this.props.parameter.id, eval(value));
    }
  };

  /** Slider parameter changes handle method */
  onSliderChange = value => {
    this.setState({
      ...this.state,
      currentValue: value
    });
  };

  // when mouse up fired after dragging slider, update current value on parameter
  afterSliderChange = value => {
    this.props.updateCurrentValue(this.props.parameter.id, value);
  };

  // Edit button element
  editButton = id => {
    return (
      <Tooltip title={i18n.t("Edit")}>
        <ToolOutlined
          name={"whatIfEditButton"}
          onClick={() => this.editParameter(id)}
          className={"circle-icon"}
          style={{ cursor: "pointer", margin: "5px 0px 0px" }}
        ></ToolOutlined>
      </Tooltip>
    );
  };

  // Set selected parameter for edit.
  editParameter = id => {
    this.props.setSelectedParameters(id);
  };

  // Remove button element
  removeButton = id => {
    return (
      <Tooltip title={i18n.t("Delete")}>
        <DeleteOutlined
          name={"whatIfDeleteButton"}
          onClick={() => this.removeParameter(id)}
          className={"circle-icon"}
          style={{
            cursor: "pointer",
            color: "#e87d7d",
            borderColor: "#e87d7d",
            margin: "5px 0px 0px"
          }}
        ></DeleteOutlined>
      </Tooltip>
    );
  };

  //remove parameter with id in list
  removeParameter = id => {
    this.props.removeParameter(id);
  };

  // Slider component for parameter
  sliderComponent = (
    dataType,
    defaultValue,
    minValue,
    maxValue,
    incrementValue,
    id
  ) => {
    return (
      <div style={{ width: "100%" }}>
        <div
          style={{
            width: "100%",
            textAlign: "center",
            fontWeight: "bold",
            color: "#509665",
            fontSize: 12,
            height: "18px",
            lineHeight: "18px"
          }}
        >
          {formatter(this.state.currentValue, dataType)}
        </div>
        <Slider
          tipFormatter={value => formatter(value, dataType)}
          defaultValue={convertNumber(defaultValue, dataType)}
          value={convertNumber(this.state.currentValue, dataType)}
          min={convertNumber(minValue, dataType)}
          max={convertNumber(maxValue, dataType)}
          onChange={this.onSliderChange}
          onAfterChange={this.afterSliderChange}
          step={convertNumber(incrementValue, dataType)}
          key={id}
          tooltipVisible={false}
          style={{ margin: "4px 0" }}
        />
      </div>
    );
  };

  //input component for parameter
  inputComponent = (defaultValue, minValue, maxValue, id, dataType, incrementValue) => {
    return (
      <div style={{ margin: "0" }}>
        <InputNumber
          style={{ width: "100%" }}
          id={id}
          onPressEnter={(e) => this.onTriggerUpdate(e, minValue, maxValue, dataType)}
          value={this.state.currentValue}
          min={minValue}
          max={maxValue}
          defaultValue={defaultValue}
          size="small"
          step={convertNumber(incrementValue, dataType)}
          onChange={(value) => this.onChange({ target: { value } }, minValue, maxValue, dataType)}
          onBlur={(e) => this.onTriggerUpdate(e, minValue, maxValue, dataType)}
          decimalSeparator={numberSeparator}
        ></InputNumber>
      </div>
    );
  };

  // Decider of input or slider parameter
  renderByShowType = (
    showType,
    dataType,
    defaultValue,
    minValue,
    maxValue,
    incrementValue,
    id
  ) => {
    if (showType === TYPE_SLIDER) {
      return this.sliderComponent(
        dataType,
        defaultValue,
        minValue,
        maxValue,
        incrementValue,
        id
      );
    } else if (showType === TYPE_INPUT) {
      return this.inputComponent(
        defaultValue,
        minValue,
        maxValue,
        id,
        dataType,
        incrementValue
      );
    }
  };

  render() {
    let {
      id,
      defaultValue,
      dataType,
      showType,
      minValue,
      maxValue,
      incrementValue,
      name,
      displayName
    } = this.props.parameter;

    if (incrementValue === null) {
      incrementValue = 1;
    }

    return (
      <div
        className={"parameter-row"}
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          gap: "4px"
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: this.props.isScreenModeMobile ? "100%" : "calc(100% - 74px)",
            gap: "4px"
          }}
        >
          <div
            style={{
              height: "35px",
              width: this.props.isScreenModeMobile ? "25%" : "calc((100% - 9px) * 0.15)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              overflow: "hidden",
              paddingRight: "4px"
            }}
          >
            <Tooltip title={displayName} placement={"topLeft"}>
              <div 
                className={"parameter-display-name"} 
                style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", lineHeight: "1.2" }}
              >
                {displayName}
              </div>
            </Tooltip>
            <div 
              className={"small-sub-text"} 
              style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", lineHeight: "1.2" }}
            >
              {name}
            </div>
          </div>

          <div style={{ height: "35px", width: "1px", backgroundColor: "#ececec" }} />

          <div
            style={{
              minWidth: this.props.isScreenModeMobile ? "75%" : "calc((100% - 9px) * 0.85)",
              width: "-webkit-fill-available",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "4px"
            }}
          >
            <div
              style={{
                textAlign: "right",
                minWidth: "fit-content",
                maxWidth: "20%",
                fontSize: 12
              }}
            >
              {showType === TYPE_SLIDER && <div style={{ height: "18px" }} />}
              <Text>{formatter(minValue, dataType)}</Text>
            </div>

            <div
              style={{
                width: "-webkit-fill-available",
                fontSize: 12,
                padding: "0 8px"
              }}
            >
              {this.renderByShowType(
                showType,
                dataType,
                defaultValue,
                minValue,
                maxValue,
                incrementValue,
                id
              )}
            </div>

            <div
              style={{
                minWidth: "fit-content",
                maxWidth: "20%",
                fontSize: 12
              }}
            >
              {showType === TYPE_SLIDER && <div style={{ height: "18px" }} />}
              <Text>{formatter(maxValue, dataType)}</Text>
            </div>
          </div>
        </div>

        {
          !this.props.isScreenModeMobile && (
            <>
              <div style={{ height: "35px", width: "1px", backgroundColor: "#ececec" }} />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "4px",
                  height: "35px",
                  textAlign: "center",
                  width: "65px"
                }}
              >
                {this.props.readOnly === "WRITE" ? this.editButton(id) : null}
                {this.props.readOnly === "WRITE" ? this.removeButton(id) : null}
              </div>
            </>
          )}
      </div>
    );
  }
}

export default Parameter;
